import * as React from "react";
import {Trans} from "react-i18next";
import ProgressBar from "../../lib/form/ProgressBar/ProgressBar";
import {useCartContext} from "../CartContextProvider/CartContextProvider";
import styles from "./ShippingCostBar.module.scss";

export const ShippingCostBar: React.FC = () => {
  const {freeShippingAbsolute, freeShippingFulfilled, freeShippingMissing} =
    useCartContext().cart.shippingInformation.freeShipping;

  if (!(freeShippingAbsolute && freeShippingFulfilled && freeShippingMissing)) {
    return null;
  }

  const absolute = freeShippingAbsolute.amount;
  const fulfilled = freeShippingFulfilled.amount;

  if (absolute === fulfilled) {
    return null;
  }

  const absoluteFormatted = freeShippingAbsolute.formatted;
  const fulfilledFormatted = freeShippingFulfilled.formatted;
  const pendingFormatted = freeShippingMissing.formatted;

  const parentCategoryProductsContainer = document.getElementById("ParentCategoryProductsContainer");
  const fittingItemsLink = parentCategoryProductsContainer?.dataset.categoryUrl;

  return (
    <div className={styles.wrapper}>
      <div className={styles.progressBar}>
        <ProgressBar
          value={+fulfilled}
          min={0}
          max={+absolute}
          labelMin={fulfilledFormatted}
          labelMax={absoluteFormatted}
        />
      </div>

      <p>
        <Trans
          i18nKey="Versandkosten sparen?"
          ns="cart"
          tOptions={{context: fittingItemsLink ? "Passende-Artikel-Link" : undefined}}
        >
          <strong>Versandkosten sparen?</strong>
          Noch<strong>{{pendingFormatted}}</strong>
          hinzufügen und wir schenken Ihnen die Versandkosten.
          <a href={fittingItemsLink}>Passende Artikel</a>
        </Trans>
      </p>
    </div>
  );
};
